exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-3afc53ea] {\n  width: 1.45em;\n  height: 1.45em;\n  vertical-align: -0.38em;\n  fill: currentColor;\n  overflow: hidden;\n}\n", ""]);

// exports
